import { render, staticRenderFns } from "./ajout-rapide-au-panier.vue?vue&type=template&id=c892e9ce&scoped=true&"
import script from "./ajout-rapide-au-panier.vue?vue&type=script&lang=js&"
export * from "./ajout-rapide-au-panier.vue?vue&type=script&lang=js&"
import style0 from "./ajout-rapide-au-panier.vue?vue&type=style&index=0&id=c892e9ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c892e9ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VForm,VSelect})
